// extracted by mini-css-extract-plugin
export default {"modal":"modal___Cie0M","btn":"btn___mFMXr"};